import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NovelistProvider } from '../novelist/novelist';
import { Events } from 'ionic-angular';
import { IpcService } from '../ipc/ipc';
import { AppState } from '../../config/state';
import moment from 'moment';
import QRious from 'qrious';
import JsBarcode from 'jsbarcode';
import { ToastAlertsProvider } from '../toast-alerts/toast-alerts';
import { IlsProvider } from '../ils/ils';
/*
  Generated class for the PrintingProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PrintingProvider {
  items: any = [];
  count: number = 0;
  inputData: any;
  showPatronName: boolean = false;
  showPatronBarcode: boolean = true;
  constructor(public http: HttpClient, private novelist: NovelistProvider, private events: Events, private ipc: IpcService, public state: AppState, private toast: ToastAlertsProvider, private ilsProvider: IlsProvider) {

  }

  printCheckoutItemReceipt(data, byPassLogout?:boolean, msgTimer?:number):Promise<boolean> {
    return new Promise((res,rej)=>{
      this.inputData = null;
      this.items = [];
      this.inputData = data;
      this.count = 0;
      // this.toast.triggerToast('Printing Receipt...', '', 'success', 4000);
      this.buildReceipt().then(receipt => {
        window.Bridge.coPrint({
        patron: data.patron,
        receipt: receipt,
        screenType: data.screenType
        });
        if(!byPassLogout) return res(true)
        return res(false);
      });
    });

  }

  printUpdatedItemsReceipt(data):Promise<boolean> {
    return new Promise((res,rej)=>{
      // this.toast.triggerToast('Printing Receipt...', '', 'success', 4000);
      this.buildUpdatedItemsReceipt(data).then(receipt => {
        window.Bridge.coPrint({
          patron: data.patron,
          receipt: receipt,
          screenType: data.screenType
        });
        return res(true);
      });
    });
  }


  async buildUpdatedItemsReceipt(data){
    let items = data.reduce((count, itm) =>{
      if(!count[itm.type]) count[itm.type] = [];
      count[itm.type].push(itm);
      return count
    },{});

    let printHTML = '';
    let submitTime = moment();
    let headerFields = {
      dateToday: moment().format('MMMM DD, YYYY'),
      patronId: this.state.patron.id,
      patronBarcode: `Card number: xxxxxxxxxx${this.state.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}`,
      time: moment().format("h:mma MMMM DD, YYYY")
    }
    let footerFields = {
    }
    let header = this.state.receiptTemplates['updateReceipt'].header;
    let footer = this.state.receiptTemplates['updateReceipt'].footer;
    let content = this.state.receiptTemplates['updateReceipt'].content;

    //header section
    if (header.length > 0){
      for (var key in headerFields) {
        let regExp = new RegExp(`{{${key}}}`, 'g');
        header = header.replace(regExp, headerFields[key]);
      };
      printHTML+= header;
    }
    //content section
    for(let key in items){
      // console.log(items[key], content[key], content, items);
      // console.log(items);
      let sectionTitle;
      switch(key){
        case('return'):
          sectionTitle = 'Returned Items';
        break;
        case ('cancelHold'):
          sectionTitle = 'Holds Cancelled';
        break;
        case ('checkout'):
          sectionTitle = 'Checkouts';
        break;
        case ('renew'):
          sectionTitle = 'Renewals';
        break;
        case ('checkin'):
          sectionTitle = 'Check-ins';
        break;
        case ('failedrenew'):
          sectionTitle = 'Failed Renewals';
        break;
        default:
          sectionTitle = '';
        break;
      }
      let sectionHtml = content[key];
      printHTML += `<div style='height: 1px; border-top: 1px solid black; margin: 14px 0;'></div><div style='font-weight: 700;margin-top: 6px;text-align:center;'>${sectionTitle}</div>`
      items[key].forEach((item, i) => {
        // console.log(item)
        let returnDateHTML, simpleReturnDateHTML, holdInformation;
        let contentString = sectionHtml;
        if (item.dueDate) {
          let returnDate = moment(item.dueDate).format("ddd D MMMM YYYY");
          let simpleReturnDate = moment(item.dueDate).format("MM-DD-YY");
          returnDateHTML = `
            <div style="font-weight: 700">DUE FOR RETURN BY</div>
            <div style="font-weight: 700">${returnDate}</div>
          `;
          simpleReturnDateHTML = `
            <div style="font-weight: 700">Due: ${simpleReturnDate}</div>
          `;
        // } else if (item.)
        } else {
          returnDateHTML = `
            <div style="font-weight: 700">Error with request, please see a librarian for assistance</div>
          `;
          simpleReturnDateHTML = `<div style="font-weight: 700">Error with request, please see a librarian for assistance</div>`;
        }

        if (item.statusCode){
          if (item.postion <= 0 && ['b','j','i'].indexOf(item.statusCode)!==-1){
            holdInformation = `${item.status}`;
          } else if (item.postion <= 0 && ['b','j','i'].indexOf(item.statusCode)==-1){
            holdInformation = `Ready Soon`;
          } else {
            holdInformation = `Position: ${item.postion} of ${item.queueLength}`;
          }
        } else if (item.postion){
          holdInformation = `Position: ${item.postion} of ${item.queueLength}`;
        } else {
          holdInformation = ''
        }

        // if (item.amount){
        //   totalAmount += Number(item.amount);
        // }

        let title,itemID,isbn;
        if (item.item){
          title = item.item.titleIdentifier;
          itemID = item.item.itemIdentifier;
          item.item.isbn? isbn = item.item.isbn : isbn = '';
        } else if (item.bib){
          title = item.bib.title;
          itemID = item.id;
          if (item.bib.isbns){
            isbn = item.bib.isbns[0];
          } else if (item.bib.isbn){
            isbn = item.bib.isbn;
          } else {
            isbn = '';
          }
        } else {
          title = '';
          itemID = item.id;
          isbn = '';
        }

        let contentFields = {
          sectionTitle: sectionTitle,
          number: i+1,
          title: title,
          time: submitTime.format("h:mma MM/DD/YYYY"),
          itemID: itemID,
          bibID: item.bib? item.bib.id : '',
          barcode: item.barcode? item.barcode : '',
          returnDate: returnDateHTML,
          simpleReturnDate: simpleReturnDateHTML,
          isbn: isbn,
          author: item.bib? item.bib.author : '',
          holdInformation: holdInformation,
          holdStatus: item.status || '',
          position: item.postion || '',
          queueLength: item.queueLength || '',
          pickupLocation: item.pickupLocation? item.pickupLocation.name : '',
          fineAmount: item.amount? item.amount.toFixed(2) : '',
          fineDescription: item.description || '',
          amountPaid: item.amountPaid? item.amountPaid.toFixed(2) : ''
        }
        for (var key in contentFields) {
          let regExp = new RegExp(`{{${key}}}`, 'g');
          contentString = contentString.replace(regExp, contentFields[key]);
        };
        printHTML+= contentString;
      });
    }

    //footer section
    if (footer.length > 0){
      for (var key in footerFields) {
        let regExp = new RegExp(`{{${key}}}`, 'g');
        footer = footer.replace(regExp, footerFields[key]);
      };
      printHTML+= footer;
    }
    return printHTML;

  }

  printCurrentCheckoutsHolds(data) {
    // this.events.subscribe('readyToPrintNow', (args) => {
    // this.count += args
    // if (this.count >= data.idents.length) {
    this.inputData = data;
    this.buildReceiptRenewHolds().then(receipt => {
      this.toast.triggerToast(`Printing ${data.screenType}...`, '', 'success', 4000);
      window.Bridge.coPrint({
        patron: data.patron,
        receipt: receipt,
        screenType: data.screenType
      });
    })
    // }
    // })
  }

  private getSimilarTitles(idents) {
    if (idents && idents.length > 0) {
      let done = false;
      idents.forEach(async ident => {
        if (done) return;
        let result;
        if (ident.type == 'isbn') {
          result = await this.novelist.getItemDetailsFromISBN(ident.id);
        } else if (ident.type == 'upc') {
          result = await this.novelist.getItemDetailsFromUPC(ident.id);
        }else if (ident.type=='barcode'){
          result = await this.novelist.getItemDetailsFromBarcode(ident.id);
        }
        // console.log(result)
        if (result && result.similarTitles) {
          done = true;
          this.items.push(result.similarTitles.map(item => {
            item.cover = `http://covers0.communico.co/isbn/o/${item.primaryISBN}.jpg`;
            // item.error = "http://placehold.it/100x150&text="+encodeURIComponent(item.title);
            item.error = "http://covers0.communico.co/gen/cover?title=" + encodeURIComponent(item.title);
            return item;
          }));
          this.events.publish('readyToPrintNow', 1);
        } else {
          done = true;
          this.events.publish('readyToPrintNow', 1);
        }
      });
    }
  }

  private async buildReceipt() {
	// <img src="https://toledo.libnet.info//images/toledo/toledo-receipt-logo-8.png" >

  // console.log('printed', this.items)
    let printHTML = "";
    if (this.state.receiptTemplates){
      let headerFields = {
        dateToday: moment().format('MMMM DD, YYYY'),
        patronId: this.inputData.patron.id,
        patronBarcode: `Card number: xxxxxxxxxx${this.inputData.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}`,
        itemCount: this.inputData.receiptInfo.length,
        time: moment().format("h:mma MMMM DD, YYYY")
      }
      let footerFields = {
        itemCount: this.inputData.receiptInfo.length,
        finesTotal: '',
        totalCost: this.inputData.totalCost
      };
      let header = this.state.receiptTemplates[this.inputData.screenType.toLowerCase()].header || "";
      let footer = this.state.receiptTemplates[this.inputData.screenType.toLowerCase()].footer || "";
      let content = this.state.receiptTemplates[this.inputData.screenType.toLowerCase()].content || "";

      //header section
      if (header.length > 0){
        for (var key in headerFields) {
          let regExp = new RegExp(`{{${key}}}`, 'g');
          header = header.replace(regExp, headerFields[key]);
        };
        printHTML+= header;
      }
      let totalAmount = 0;
      //content section
      this.inputData.receiptInfo.forEach((item, i) => {
        // console.log(item)
        let returnDateHTML, simpleReturnDateHTML, holdInformation;
        let contentString = content;
        if(item.returnDate) item.dueDate = item.returnDate;
        if (item.dueDate) {
          let returnDate = moment(item.dueDate).format("ddd D MMMM YYYY");
          let simpleReturnDate = moment(item.dueDate).format("MM-DD-YY");
          returnDateHTML = `
            <div style="font-weight: 700">DUE FOR RETURN BY</div>
            <div style="font-weight: 700">${returnDate}</div>
          `;
          simpleReturnDateHTML = `
            <div style="font-weight: 700">Due: ${simpleReturnDate}</div>
          `;
        // } else if (item.)
        } else {
          returnDateHTML = `
            <div style="font-weight: 700">Error with request, please see a librarian for assistance</div>
          `;
          simpleReturnDateHTML = `<div style="font-weight: 700">Error with request, please see a librarian for assistance</div>`;
        }

        if (item.statusCode){
          if (item.postion <= 0 && ['b','j','i'].indexOf(item.statusCode)!==-1){
            holdInformation = `${item.status}`;
          } else if (item.postion <= 0 && ['b','j','i'].indexOf(item.statusCode)==-1){
            holdInformation = `Ready Soon`;
          } else {
            holdInformation = `Position: ${item.postion} of ${item.queueLength}`;
          }
        } else if (item.postion){
          holdInformation = `Position: ${item.postion} of ${item.queueLength}`;
        } else {
          holdInformation = ''
        }

        if(item.isCancelled) holdInformation = 'Cancelled';

        if (item.amount){
          totalAmount += Number(item.amount);
        }

        let title,itemID;
        if (item.item){
          title = item.item.titleIdentifier;
          itemID = item.item.itemIdentifier;
        } else if (item.bib){
          title = item.bib.title;
          itemID = item.id;
        } else {
          title = '';
          itemID = item.id;
        }

        let contentFields = {
          number: i+1,
          itemCount: this.inputData.receiptInfo.length,
          title: item.title ? item.title : title,
          time: this.inputData.submitTime.format("h:mma MM/DD/YYYY"),
          itemID: itemID,
          bibID: item.bib? item.bib.id : '',
          barcode: item.barcode? item.barcode : '',
          returnDate: returnDateHTML,
          simpleReturnDate: simpleReturnDateHTML,
          isbn: item.bib && item.bib.isbns && item.bib.isbns.length > 0 ? item.bib.isbns[0] : '',
          author: item.bib? item.bib.author : '',
          holdInformation: holdInformation,
          holdStatus: item.status || '',
          position: item.postion || '',
          queueLength: item.queueLength || '',
          pickupLocation: item.pickupLocation? item.pickupLocation.name : '',
          fineAmount: item.amount? item.amount.toFixed(2) : '',
          fineDescription: item.description || '',
          amountPaid: item.amountPaid? item.amountPaid.toFixed(2) : ''
        }
        for (var key in contentFields) {
          let regExp = new RegExp(`{{${key}}}`, 'g');
          contentString = contentString.replace(regExp, contentFields[key]);
        };
        printHTML+= contentString;
      });

      footerFields.finesTotal = totalAmount.toFixed(2) || '';
      //footer section
      if (footer.length > 0){
        for (var key in footerFields) {
          let regExp = new RegExp(`{{${key}}}`, 'g');
          footer = footer.replace(regExp, footerFields[key]);
        };
        printHTML+= footer;
      }

    }else {
      let submitionTime = this.inputData.submitTime.format("h:mma MM/DD/YYYY");
      let clientName, patronBarcode, patronName, patronID;
      this.showPatronName? patronName = `${this.inputData.patron.firstName} ${this.inputData.patron.lastName}` : patronName = "";
      this.state.customStrings.receipt.libraryName ? clientName = this.state.customStrings.receipt.libraryName : clientName = this.state.client.name;
      this.showPatronBarcode? patronBarcode = `Card number: xxxxxxxxxx${this.inputData.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}` : patronBarcode = "";
      if (this.state.customStrings.receipt && this.state.customStrings.receipt.showPatronBarcode){
        patronID = patronBarcode;
      } else {
        patronID = `Items checked out to: ${this.inputData.patron.id}`;
      }
      printHTML = `
      <div style='margin-bottom: 30px;'>
      <div>
    <img src='${this.state.customImages.clientLogos.receipt}' >
      </div>
      <div style='text-align: center; font-size: 24px; margin: 10px 0'>${this.inputData.screenType.toUpperCase()} RECEIPT</div>
      <div style='height: 1px; border-bottom: 1px solid black; margin: 10px 0'></div>
      <div style='text-align: center;'>
        <div style='text-transform: capitalize;'>${clientName}</div>
        <div style='text-transform: capitalize;'>${moment().format('MMMM DD, YYYY')}</div>
        <div>${patronID} </div>
        <div>Total items checked out: ${this.inputData.receiptInfo.length}</div>

        </div>
        <div style='height: 1px; border-top: 1px solid black; margin: 10px 0;'></div>
          `
      // <div>Card number: ${this.inputData.patron.barcode}</div>
      this.inputData.receiptInfo.forEach((checkout, i) => {
        let canvas = document.createElement('canvas');
        let itemId;
        JsBarcode(canvas, checkout.item.itemIdentifier, {
          format: "code128",
          displayValue: false,
          height: 60
        });
        let returnDateHTML;
        if (checkout.dueDate) {
          let returnDate = moment(checkout.dueDate).format("ddd D MMMM YYYY");
          returnDateHTML = `
            <div style="font-weight: 700">DUE FOR RETURN BY</div>
            <div style="font-weight: 700">${returnDate}</div>
          `
        } else {
          returnDateHTML = `
            <div style="font-weight: 700">Error with request, please see a librarian for assistance</div>
          `
        }
        // console.log(this.state.customStrings)
        if (this.state.customStrings.receipt && this.state.customStrings.receipt.hideItemBarcodes){
          itemId = `<div >Item Barcode: ${checkout.item.itemIdentifier}</div>`
        } else {
          itemId = `<img src="${canvas.toDataURL()}" />`
        }
        let html = `
        <div style="text-align: center; margin-top: 14px;">
          <div style="margin-bottom: 14px;">${i + 1} of ${this.inputData.receiptInfo.length} item(s)</div>
          <div style="font-weight: 700;">${checkout.item.titleIdentifier}</div>
          <div>${this.inputData.pastTense} at:</div>
          <div style="margin-bottom: 14px;">${submitionTime}</div>
          ${itemId}
          <div style="margin-top: 6px;">${returnDateHTML}</div>
          <div style="height: 1px; border-top: 1px solid black; margin: 6px 0;"></div>
          </div>`
          // <div style="height: 1px; border-top: 1px solid black; margin: 6px 0;"></div>
        printHTML += html;
      });
      if (this.inputData.novelistResults && this.inputData.novelistResults.length > 0) {
      let similarArray = this.inputData.novelistResults[0].similarTitles.slice(0, 3);
      // console.log(similarArray, similarArray.length);
        printHTML += `
          <div style="margin: 12px 0;margin-top:24px; text-align: center; font-size: 18px;">
            SIMILAR ITEMS YOU MAY LIKE
          </div>
          <div style="margin-bottom: 24px; text-align: center; font-size: 16px;">
            Scan the QR code with a smart phone to view details
          </div>
        `
        similarArray.forEach((item, i) => {
          let html;
          const el = document.createElement('canvas')
          let qrCode = new QRious({
            level: "H",
            size: "100",
            value: item.primaryISBN,
            element: el
          })
          html = `
            <div style="border-bottom: 1px solid black; margin: 10px 0;height: 220px; padding: 0 20px;">
              <div style="font-weight: 700; font-size: 16px; text-transform:capitalize;text-align: center;">${item.title}</div>
              <div style="text-align: center;" >${item.author}</div>
              <div style="text-align: center;">
                <img style="margin: 10px auto;" src="${el.toDataURL()}">
              </div>
            </div>
            `
          printHTML += html
        });
      }
      // <img style="margin:5px;" src=${item.cover} > COVER FOR RECEIPT IF WE WANT BACK
      let footerMessage;
      this.state.customStrings[this.inputData.screenType.toLowerCase()] && this.state.customStrings[this.inputData.screenType.toLowerCase()].receiptMessage? footerMessage = this.state.customStrings[this.inputData.screenType.toLowerCase()].receiptMessage : footerMessage = "";
      printHTML += `
        <div style="text-align:center;">${this.state.customStrings.receipt.footerMessage}</div>
        <div style="text-align:center;">${footerMessage}</div>
      `
      printHTML += `</div>`
    }
    return printHTML;
  }

  private async buildReceiptRenewHolds() {
    // let similarArray = this.items[0].slice(0, 5);
    // let submitionTime = this.inputData.submitTime.format("h:mma MM/DD/YYYY");
    let clientName;
    this.state.client.longName ? clientName = this.state.client.longName : clientName = this.state.client.name;
    let printHTML, patronName, patronBarcode;
    let currentTime = moment().format("h:mma MM/DD/YYYY")
    const title = this.inputData.screenType !== 'Holds' ? 'MY CHECKOUTS' : 'MY HOLDS';
    this.showPatronName? patronName = `${this.inputData.patron.firstName} ${this.inputData.patron.lastName}` : patronName = "";
    this.showPatronBarcode? patronBarcode = `Card #: xxxxxxxxxx ${this.inputData.patron.barcode.split('').reverse().slice(0, 4).reverse().join('')}` : patronBarcode = "";
    printHTML = `
    <div>
      <div>
        <img src="https://cuyahoga.libnet.info/images/tile/cuyahoga/main%20site%20header/cuyahoga-receipt-printer-logo.png" >
      </div>
      <div style="text-align: center; font-size: 24px; width: 260px; margin: 10px auto;">${title}</div>
      <div style="height: 1px; border-bottom: 1px solid black; margin: 10px 0"></div>
      <div style="text-align: center;">
        <div>Patron Record #: ${this.inputData.patron.id} </div>
        <div>${patronName}</div>
        <div>${patronBarcode}</div>
        <div style="text-transform: capitalize;">${clientName}</div>
        <div>${currentTime}</div>
      </div>
      <div style="height: 1px; border-top: 1px solid black; margin: 10px 0;"></div>
    `
    this.inputData.receiptInfo.forEach((item, i) => {
      let canvas = document.createElement('canvas');
      // console.log('barcode', item)
      JsBarcode(canvas, item.id, {
        format: "code128",
        displayValue: false,
        height: 60
      });
      let returnDateHTML = '';
      let postionHTML = '';
      let idText = '';
      let pickupLocation = '';

      let returnDate = moment(item.dueDate).format("ddd D MMMM YYYY");
      if (this.inputData.screenType !== 'Holds') {
        // <div style="height: 1px; border-top: 1px solid black; margin: 6px 0;"></div>
        returnDateHTML = `
          <div>
            <div style="font-weight: 700">DUE FOR RETURN BY</div>
            <div style="font-weight: 700">${returnDate}</div>
          </div>
          `;
        idText = 'Checkout ID'
      } else {
        if (parseInt(item.postion) < 1) {
          if (item.pickupLocation) pickupLocation = `from ${item.pickupLocation.name} branch`;
          postionHTML = `<div>Ready for pick-up ${pickupLocation}</div>`
        } else {
          postionHTML = `<div>Hold position: ${item.postion} of ${item.queueLength}</div>`
        };
        idText = 'Hold ID';
      }

      let html = `
      <div style="text-align: center; margin-top: 14px;">
        <div style="margin-bottom: 14px;">${i + 1} of ${this.inputData.receiptInfo.length} item(s)</div>
        <div style="font-weight: 700;">${item.bib.title}</div>
        <div>${item.bib.author} ${item.bib.publishYear}</div>
        <div style="margin-bottom: 14px;">Format: ${item.bib.format}</div>
        ${postionHTML}
        ${returnDateHTML}

        <div style="height: 1px; border-top: 1px solid black; margin: 6px 0;"></div>
      </div>`
      printHTML += html;
    });

    // if (similarArray.length > 0) {
    //   similarArray = similarArray.slice(0,3);
    //   console.log(similarArray, similarArray.length);
    //   printHTML += `
    //     <div style="margin: 12px 0;margin-top:24px; text-align: center; font-size: 18px;">
    //       SIMILAR ITEMS YOU MAY LIKE
    //     </div>
    //     <div style="margin-bottom: 24px; text-align: center; font-size: 16px;">
    //       Scan the QR code with a smart phone to view details
    //     </div>
    //   `
    //   similarArray.forEach((item, i) => {
    //     let html;
    //     const el = document.createElement('canvas')
    //     let qrCode = new QRious({
    //       level: "H",
    //       size: "100",
    //       value: item.primaryISBN,
    //       element: el
    //     })
    //       html = `
    //        <div style="border-bottom: 1px solid black; margin: 10px 0;height: 220px; padding: 0 20px;">
    //          <div style="font-weight: 700; font-size: 16px; text-transform:capitalize;text-align: center;">${item.title}</div>
    //          <div style="text-align: center;" >${item.author}</div>
    //          <div style="text-align: center;">
    //           <img style="margin: 10px auto;" src="${el.toDataURL()}">
    //          </div>
    //        </div>
    //        `
    //     printHTML += html
    //   });
    // }
    // <img style="margin:5px;" src=${item.cover} > COVER FOR RECEIPT IF WE WANT BACK

    printHTML += `</div>`

    return printHTML;
  }

}



// WEBPACK FOOTER //
// ./src/providers/printing/printing.ts